module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "ls-sidebar"
  }, [_c('dropdown', {
    class: 'ls-dropdown ls-user-account',
    attrs: {
      "width": '100%'
    }
  }, [_c('a', {
    staticClass: "ls-ico-user",
    attrs: {
      "href": "#"
    },
    slot: "trigger"
  }, [_c('span', {
    staticClass: "ls-name"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v("\n      (" + _vm._s(_vm.seller.email) + ")\n    ")]), _vm._v(" "), _c('nav', {
    staticClass: "ls-dropdown-nav ls-user-menu",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "list"
  }, [_c('a', {
    staticClass: "ls-btn-logout",
    attrs: {
      "href": "#",
      "role": "combobox",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu_user.logout')))])])]), _vm._v(" "), _c('div', {
    staticClass: "ls-sidebar-inner"
  }, [_c('nav', {
    staticClass: "ls-menu",
    attrs: {
      "role": "navigation"
    }
  }, [_c('ul', {
    attrs: {
      "role": "menu"
    }
  }, [_c('authorized-link', {
    attrs: {
      "tag": "index_contract"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    staticClass: "ls-ico-week",
    attrs: {
      "to": {
        name: 'contracts'
      },
      "role": "menuitem",
      "title": _vm.$t('application.menu.contracts')
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.contracts')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_plan"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    staticClass: "ls-ico-docs",
    attrs: {
      "to": {
        name: 'plans'
      },
      "title": _vm.$t('application.menu.plans'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.plans')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_customer"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    staticClass: "ls-ico-users",
    attrs: {
      "to": {
        name: 'customers'
      },
      "title": _vm.$t('application.menu.clients'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.clients')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_invoice"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    staticClass: "ls-ico-origins",
    attrs: {
      "to": {
        name: 'invoices'
      },
      "title": _vm.$t('application.menu.invoices'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.invoices')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_invoice"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    staticClass: "ls-ico-shaft-up",
    attrs: {
      "to": {
        name: 'orders'
      },
      "title": _vm.$t('application.menu.orders'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.orders')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_setting"
    }
  }, [_c('li', {
    staticClass: "ls-submenu-parent ls-overflow-hidden",
    class: {
      'ls-active': _vm.showMenu
    },
    attrs: {
      "aria-expanded": _vm.showMenu,
      "aria-hidden": !_vm.showMenu
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dropdownToggle($event)
      }
    }
  }, [_c('a', {
    staticClass: "ls-ico-cog",
    attrs: {
      "href": "javascript:void(0)",
      "title": _vm.$t('application.menu.setup'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.setup')))]), _vm._v(" "), (_vm.showMenu) ? _c('ul', {
    staticClass: "ls-submenu",
    attrs: {
      "role": "menu"
    }
  }, [_c('authorized-link', {
    attrs: {
      "tag": "update_seller"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'general'
      },
      "title": _vm.$t('application.menu.general_settings'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.general_settings')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_setting"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'payment_settings'
      },
      "title": _vm.$t('application.menu.payment_settings'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.payment_settings')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'billing_settings'
      },
      "title": _vm.$t('application.menu.billing_settings'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.billing_settings')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'webhook_settings'
      },
      "title": _vm.$t('application.menu.webhook_settings'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.webhook_settings')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'nfe_settings'
      },
      "title": _vm.$t('application.menu.nfe_settings'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.nfe_settings')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_tax"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'taxes'
      },
      "title": _vm.$t('application.menu.taxes'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.taxes')))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "index_user"
    }
  }, [_c('li', {
    staticClass: "ls-overflow-hidden"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      },
      "title": _vm.$t('application.menu.general_settings'),
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu.users_access')))])], 1)])], 1) : _vm._e()])])], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "ls-sidebar-toggle ls-ico-shaft-left",
    on: {
      "click": function($event) {
        _vm.resizeSidebar()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51a0a290"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layouts/components/sidebar.vue
// module id = 779
// module chunks = 1